(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('HomeController', HomeController)

    /** @ngInject */
    function HomeController($rootScope, $scope, HelperService, AuthenticationService, ApplicationService, DATA_EVENTS) {
        const vm = this;

        vm.getImagePath = application => {
            return HelperService.imageHandlerPath('application', application.Id, application.Image);
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getApplications() {
            HelperService.startLoading('.page-content');

            const accessLevelId = AuthenticationService.getUserData().AccessLevel.Id;

            if (!accessLevelId) {
                HelperService.stopLoading('.page-content');
                return;
            }

            ApplicationService
                .getAllByAccessLevel(accessLevelId)
                .then(success => {
                    vm.applications = success;

                    HelperService.stopLoading('.page-content');
                }, error => {
                    HelperService.stopLoading('.page-content');
                    HelperService.errorCallback(error);
                })
        }

        function init() {
            getApplications();
        }
    }
}());